export enum CustomerStatus {
    ACTIVE = 'Active',
    INACTIVE = 'Inactive',
    SUSPENDED = 'Suspended',
    TERMINATED = 'Terminated',
    PENDINGKYC = 'Pending KYC',
    PENDINGKYB = 'Pending KYB',
    VERIFIED = 'Verified',
    PENDINGIDVERIFICATION = 'Pending IDV',
    LOCK = 'Locked',
    INITIATED = 'Initiated',
    PENDING = 'Pending',
    APPROVED = 'Approved',
    RETURNED = 'Returned',
    REJECTED = 'Rejected',
    EXECUTED='Executed',
    FAILED='Failed',
    CREATED='Created',
    COMPLETED = 'Completed',
}

export enum RiyadCustomerStatus {
    ACTIVE = 'Active',
    SUSPENDED = 'Suspended',
    TERMINATED = 'Terminated',
    INACTIVE = 'Inactive',
}

export enum CustomerOnboardingStatus {
    ACTIVE = 'Active',
    SUSPENDED = 'Suspended',
    TERMINATED = 'Terminated',
    PENDINGKYC = 'Pending KYC',
    PENDINGIDVERIFICATION = 'Pending IDV',
}

export enum CustomerOnboardingStatusLabels {
    ACTIVE = 'Active',
    SUSPENDED = 'Suspended',
    TERMINATED = 'Terminated',
    PENDINGKYC = 'Pending Approval',
    PENDINGIDVERIFICATION = 'Pending Approval',
}

export enum CustomerStatusLabels {
    ACTIVE = 'Active',
    INACTIVE = 'Inactive',
    SUSPENDED = 'Suspended',
    TERMINATED = 'Terminated',
    PENDINGKYC = 'Pending KYC',
    PENDINGKYB = 'Pending KYB',
    PENDINGIDVERIFICATION = 'Pending ID Verification',
    LOCK = 'Locked',
    INITIATED = 'Initiated',
    PENDING = 'Pending',
    APPROVED = 'Approved',
    RETURNED = 'Returned',
    REJECTED = 'Rejected',
    EXECUTED='Executed',
    FAILED='Failed',
    CREATED='Created',
    COMPLETED = 'Completed',
}

export enum RiyadCustomerStatusLabels {
    ACTIVE = 'Active',
    SUSPENDED = 'Suspended',
    TERMINATED = 'Terminated',
}
